import { Component, Fragment } from 'react';
import '../../../fslightbox/fslightbox';
import '../../../fslightbox/fslightbox.css';
import { isEqual } from 'es-toolkit';
import { getImagesByQuality, SIZE_TYPE } from '../../helpers';
import { LightboxContext } from './LightboxProvider';

const createCategoryMarkup = (categories) => {
  return categories
    .map((category, index) => {
      const separator =
        index > 0
          ? '<span class="fslightbox-caption-categories-separator"> · </span>'
          : '';
      const categoryCaption = category
        ? `<span class="fslightbox-caption-categories-category">${category}</span>`
        : '';

      return `${separator}${categoryCaption}`;
    })
    .join('');
};

const getCurrentCategories = (allCategories, itemCategories) => {
  return allCategories.reduce((acc, category) => {
    if (itemCategories.includes(category.id)) {
      acc.push(category.name);
    }

    return acc;
  }, []);
};

const createCaptions = (sources, allCategories) => {
  return sources.map((item) => {
    const currentCategories = getCurrentCategories(
      allCategories,
      item.categories
    );
    const categoriesMarkup = createCategoryMarkup(currentCategories);

    return {
      title: item.title ? `<div>${item.title}</div>` : null,
      description: item.description ? `<div>${item.description}</div>` : null,
      categories: categoriesMarkup ? `<div>${categoriesMarkup}</div>` : null
    };
  });
};

export class Lightbox extends Component {
  static contextType = LightboxContext;

  constructor(props) {
    super(props);
    this.state = { lightbox: null };
  }

  componentDidUpdate(prevProps) {
    const {
      toggleLightbox,
      imageCopyProtection,
      watermarkText,
      watermarkTextSize,
      watermarkPosition,
      watermarkType,
      watermarkLogo,
      watermarkLogoSize,
      sources,
      sourceLink,
      showLightbox,
      lightboxContainerClass
    } = this.context;
    const { allCategories } = this.props;

    if (showLightbox && !this.state.lightbox) {
      // oxlint-disable-next-line no-undef
      const lightbox = new fsLightboxClass();
      lightbox.data.updateWatermarkFunctions = [];
      this.setState(
        {
          lightbox
        },
        () => {
          this.state.lightbox.element.addEventListener('slidechange', () => {
            this.state.lightbox.caption.showCurrentCaption();
          });

          this.state.lightbox.element.addEventListener('close', () => {
            toggleLightbox(false);
          });

          this.state.lightbox.element.addEventListener('open', () => {
            document
              .getElementById('fslightbox-container')
              .classList.add(lightboxContainerClass);
          });

          this.state.lightbox.init();
          this.state.lightbox.setSlide(sourceLink);
          this.state.lightbox.caption.showCurrentCaption();
        }
      );
    } else if (
      ((this.state.lightbox && !showLightbox) ||
        !isEqual(prevProps.sources, sources)) &&
      this.state.lightbox &&
      this.state.lightbox.close
    ) {
      this.state.lightbox.close();

      this.setState({
        lightbox: null
      });
    } else if (this.state.lightbox) {
      const mainImages = getImagesByQuality(sources, SIZE_TYPE.LARGE);
      const thumbnailsImages = getImagesByQuality(sources, SIZE_TYPE.SMALL);
      this.state.lightbox.data.urls = mainImages.map(({ image }) => image?.url);
      this.state.lightbox.data.thumbnails = thumbnailsImages.map(
        ({ image }) => image?.url
      );
      this.state.lightbox.data.captions = createCaptions(
        sources,
        allCategories
      );
      this.state.lightbox.data.showThumbnailsOnInit = true;
      this.state.lightbox.data.showDefaultThumbnailButton = false;
      this.state.lightbox.data.imageCopyProtection = imageCopyProtection;
      this.state.lightbox.data.altAttributes = sources.map(
        (item) => item.alt || item.title
      );
      this.state.lightbox.data.watermarkText = watermarkText;
      this.state.lightbox.data.watermarkPosition = watermarkPosition.position;
      this.state.lightbox.data.watermarkTextSize = watermarkTextSize;
      this.state.lightbox.data.watermarkType = watermarkType;
      this.state.lightbox.data.watermarkUrl = watermarkLogo?.url;
      this.state.lightbox.data.watermarkLogoSize = watermarkLogoSize;
      this.state.lightbox.data.updateWatermarkFunctions.forEach(
        (updateWatermark) => {
          updateWatermark(
            watermarkText,
            watermarkPosition.position,
            watermarkTextSize,
            watermarkType,
            watermarkLogo?.url,
            watermarkLogoSize
          );
        }
      );

      if (!this.state.lightbox.elements.captions.length) {
        this.state.lightbox.elements.captions = createCaptions(
          sources,
          allCategories
        );
      }
    }
  }

  render() {
    return <Fragment></Fragment>;
  }
}
